import DeliveryAddressModelBase from '../_generated/modelBases/delivery-address-model-base';

export default class DeliveryAddressModel extends DeliveryAddressModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
